package com.patronat.top.client.presentation.profile

import com.patronat.top.core.base.ViewEvent
import com.patronat.top.core.base.ViewSideEffect
import com.patronat.top.core.base.ViewState
import com.patronat.top.dto.ProfileSuccessResponse
import com.patronat.top.dto.ReviewResponse
import com.patronat.top.library.media.data.FileSource

data class ClientProfileViewState(
    val screen: ClientProfileScreen = ClientProfileScreen.Main,
    val isLoadingProfile: Boolean = false,
    val profile: ProfileSuccessResponse? = null,
    val requiresAuth: Boolean = false,
    val editFirstName: String = "",
    val editLastName: String = "",
    val editPhone: String = "",
    val editEmail: String = "",
    val editAvatarUrl: String? = null,
    val editAvatarMediaId: String? = null,
    val isAvatarUploading: Boolean = false,
    val isSavingProfile: Boolean = false,
    val reviews: List<ReviewResponse> = emptyList(),
    val isLoadingReviews: Boolean = false,
    val contactSubject: String = "",
    val contactDescription: String = "",
    val isSendingContact: Boolean = false,
    val deleteEmail: String = "",
    val deleteReason: String = "",
    val isDeletingAccount: Boolean = false
) : ViewState

enum class ClientProfileScreen {
    Main,
    EditProfile,
    MyReviews,
    ContactUs,
    DeleteAccount
}

sealed interface ClientProfileEvent : ViewEvent {
    data object OnRefresh : ClientProfileEvent
    data object OnSignInClicked : ClientProfileEvent
    data object OnLogoutClicked : ClientProfileEvent
    data object OnBackClicked : ClientProfileEvent
    data object OnEditProfileClicked : ClientProfileEvent
    data object OnMyReviewsClicked : ClientProfileEvent
    data object OnContactUsClicked : ClientProfileEvent
    data object OnDeleteAccountClicked : ClientProfileEvent
    data class OnReviewClicked(val venueId: String) : ClientProfileEvent
    data class OnEditFirstNameChanged(val value: String) : ClientProfileEvent
    data class OnEditLastNameChanged(val value: String) : ClientProfileEvent
    data class OnEditEmailChanged(val value: String) : ClientProfileEvent
    data object OnEditAvatarClicked : ClientProfileEvent
    data class OnEditAvatarPicked(val file: ClientProfilePickedFile) : ClientProfileEvent
    data object OnSaveProfileClicked : ClientProfileEvent
    data class OnContactSubjectChanged(val value: String) : ClientProfileEvent
    data class OnContactDescriptionChanged(val value: String) : ClientProfileEvent
    data object OnSubmitContactClicked : ClientProfileEvent
    data class OnDeleteEmailChanged(val value: String) : ClientProfileEvent
    data class OnDeleteReasonChanged(val value: String) : ClientProfileEvent
    data object OnConfirmDeleteAccountClicked : ClientProfileEvent
}

sealed interface ClientProfileEffect : ViewSideEffect {
    data object OpenAuth : ClientProfileEffect
    data class OpenVenueDetails(val venueId: String) : ClientProfileEffect
    data object OpenAvatarPicker : ClientProfileEffect
}

data class ClientProfilePickedFile(
    val fileSource: FileSource,
    val mimeType: String,
    val fileName: String
)
